<template>
    <v-dialog
        content-class="addWorkOrdersWrapper"
        :value="dialog"
        fullscreen
        hide-overlay
        persistent
        transition="dialog-bottom-transition"
    >
        <div class="addWorkOrders">
            <div class="addWorkOrders_header">
                <span>{{ currentId ? 'Edit' : 'Add' }} work order</span>
                <button type="button" @click="closeDialog">
                    <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
                </button>
            </div>
            <div class="addWorkOrders_body">
                <div :class="{ 'onlyView': getPermissionAction }" class="fieldBlock flexBlock groupField">
                    <div class="groupField_wrap">
                        <field
                            margin="0"
                            width="100px"
                            label="ID"
                            :setInputValue="currentId || '-'"
                            is-readonly
                        ></field>
                        <field
                            margin="0 0 0 10px"
                            width="190px"
                            type="text"
                            label="Created date"
                            placeholder="MM/DD/YYYY"
                            display-format="YYYY-MM-DD hh:mm"
                            :dateValue="create_at"
                            is-time
                            is-disabled
                        ></field>
                        <field
                            :class-error="$v.customer_id && $v.customer_id.$error"
                            margin="0 0 0 10px"
                            width="300px"
                            label="Customer"
                            placeholder="Select customer"
                            @updateAutocomplete="onAutocomplete($event, 'customer_id')"
                            :autocompleteValue="customer_id"
                            :items="customersList"
                            :isClearable="false"
                            is-autocomplete
                        ></field>
                    </div>
                    <div class="groupField_wrap">
                        <div :style="'background:' + getIndicatorColor" v-if="status_id" class="indicator"></div>
                        <field
                            margin="0"
                            width="260px"
                            label="Status"
                            placeholder="Select status"
                            @updateSelect="onAutocomplete($event, 'status_id')"
                            :autocompleteValue="status_id"
                            :items="getWorkOrderStatusList"
                            :isClearable="false"
                            is-select
                        ></field>
                    </div>
                </div>
                <div class="groupField_wrap" :class="{ 'onlyView': getPermissionAction }">
                    <field
                        margin="0 10px 0 0"
                        width="107px"
                        label="WO Type"
                        placeholder="Select option"
                        @updateSelect="onAutocomplete($event, 'wo_type_id')"
                        :autocompleteValue="wo_type_id"
                        :items="workOrderTypeList"
                        :isClearable="false"
                        is-select
                    ></field>
                    <field
                        :class-error="$v.unit_type_id && $v.unit_type_id.$error"
                        margin="0 10px 0 0"
                        width="120px"
                        label="Unit type"
                        placeholder="Select unit type"
                        @updateSelect="onAutocomplete($event, 'unit_type_id')"
                        :autocompleteValue="unit_type_id"
                        :items="workOrderUnitTypeList"
                        :isClearable="false"
                        :is-disabled="!customer_id"
                        is-select
                        is-required
                    ></field>
                    <field
                        :class-error="$v.unit_id && $v.unit_id.$error"
                        margin="0 10px 0 0"
                        width="120px"
                        label="Unit#"
                        placeholder="Select unit"
                        @updateAutocomplete="onAutocomplete($event, 'unit_id')"
                        :autocompleteValue="unit_id"
                        :items="unitList"
                        :isClearable="false"
                        is-autocomplete
                        :is-disabled="!unit_type_id"
                        is-required
                    ></field>
                    <field
                        margin="0 10px 0 0"
                        width="100px"
                        label="Trailer type"
                        :setInputValue="trailer_type"
                        is-readonly
                    ></field>
                    <field
                        margin="0 10px 0 0"
                        width="158px"
                        label="Estimated repair time"
                        placeholder="Input time"
                        :setInputValue="estimated_time"
                        @updateInput="onInput($event, 'estimated_time')"
                    ></field>
	                <field
			                :class-error="$v.technician_id && $v.technician_id.$error"
			                margin="0 10px 0 0"
			                width="158px"
			                label="Fleet manager"
			                placeholder="Select option"
			                @updateAutocomplete="onAutocomplete($event, 'technician_id')"
			                :autocompleteValue="technician_id"
			                :items="technicianList"
			                :is-disabled="!customer_id"
			                :isClearable="false"
			                is-autocomplete
			                is-attach
			                is-required
	                ></field>
	                <div v-if="wo_type_id === 1 || !!currentId" class="groupField_wrap notPadding">
		                <field
				                v-if="wo_type_id === 2"
				                margin="0 10px 0 0"
				                width="110px"
				                label="BOX #"
				                placeholder="Select box"
				                @updateSelect="onAutocomplete($event, 'box')"
				                :autocompleteValue="box"
				                :items="boxList"
				                is-select
				                :multiValue="times"
				                :is-disabled="!!currentId"
		                ></field>
		                <field
				                :class-error="$v.check_in && $v.check_in.$error"
				                margin="0 10px 0 0"
				                width="200px"
				                type="text"
				                label="Check-in"
				                placeholder="MM/DD/YYYY HH:MM"
				                :dateValue="check_in"
				                display-format="YYYY-MM-DD hh:mm"
				                @updateTime="onTime($event, 'check_in')"
				                is-time
				                :is-disabled="wo_type_id === 2"
				                :is-required="getStatusInOut"
		                ></field>
		                <field
				                :class-error="$v.check_out && $v.check_out.$error"
				                margin="0 10px 0 0"
				                width="200px"
				                type="text"
				                label="Check-out"
				                placeholder="MM/DD/YYYY HH:MM"
				                display-format="YYYY-MM-DD hh:mm"
				                :dateValue="check_out"
				                @updateTime="onTime($event, 'check_out')"
				                is-time
				                :is-disabled="wo_type_id === 2"
				                :is-required="getStatusInOut"
		                ></field>
		                <button v-if="!!currentId && wo_type_id === 2" @click="onBoxHandler" class="boxBtn" :disabled="!times.length" :class="{'opened': isBoxHandler}">
			                <svg-sprite width="20" height="20" icon-id="arrow"></svg-sprite>
		                </button>
		                <v-expand-transition>
			                <div v-if="isBoxHandler" class="boxDropDown">
				                <template v-for="({ box_id, start_repair, id, end_repair }) in times">
					                <div :key="id" class="boxDropDown_item">
						                <field
								                margin="0 10px 0 0"
								                width="110px"
								                :text-value="box_id"
								                is-text-field
						                ></field>
						                <field
								                margin="0 10px 0 0"
								                width="200px"
								                :text-value="start_repair.slice(0, 16)"
								                is-text-field
						                ></field>
						                <field
								                margin="0"
								                width="200px"
								                :text-value="end_repair.slice(0, 16)"
								                is-text-field
						                ></field>
					                </div>
				                </template>
			                </div>
		                </v-expand-transition>
	                </div>
                </div>
	              <tab-block
			              :tab="tab"
			              :tab-list="getTabList"
			              @updateTab="onTab($event, 'tab')"
	              >
		              <v-tab-item>
			              <first-tab
					              :getUnitId="getUnitId"
					              :unit="unit_id"
					              :requestFromList="requestFromList"
					              :requestFrom="request_from"
					              :arrivalDate="arrival_date"
					              :createBy="create_by"
					              :dispatchRequestList="dispatchRequestList"
					              :trailerType="trailer_type"
					              :requestDate="request_date"
					              :optionTowing="option_towing"
					              :arrivalAmount="arrival_amount"
					              :arrivalText="arrival_text"
					              :reeferHours="+reefer_hours"
					              :isReefer="isReefer"
					              :optionAlignment="option_alignment"
					              :optionPm="option_pm"
					              :optionInspection="option_inspection"
					              :currentMileage="current_mileage"
					              :notes="notes"
					              :dispatchRequest="dispatch_request"
					              :valid="$v"
					              :description="description"
					              :actual_arrived_date="actual_arrived_date"
					              :arrived="arrived"
					              :isArrivedBlock="isArrivedBlock"
					              :getStatus="getStatus"
					              :getPermissionAction="getPermissionAction"
					              @updateFirstTab="onFirstTab"
					              @updateClearInput="onClearInput"
					              @updateDescriptionList="onDescriptionList"
					              @updateDeleteItem="onDeleteItem"
			              ></first-tab>
		              </v-tab-item>
		              <v-tab-item>
			              <second-tab
					              :files="files"
					              :createBy="create_by"
					              :getPermissionAction="getPermissionAction"
					              @updatePreviewAction="onPreviewAction"
			              ></second-tab>
		              </v-tab-item>
		              <v-tab-item>
			              -
		              </v-tab-item>
	              </tab-block>
            </div>
            <button-groups
		            :preloader="workOrdersPreloader"
		            :isSave="!getPermissionAction"
		            @updateBtnClose="closeDialog"
                @updateSave="onSave"
            ></button-groups>
            <preview-doc v-if="link" @clear-link="clearLink" :link-doc="link"></preview-doc>
        </div>
	    <preload v-if="workOrdersPreloader"></preload>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import FirstTab from "@/components/Fleet/WorkOrders/AddWorkOrders/FirstTab/FirstTab";
// async components
const SecondTab = () => import("@/components/Fleet/WorkOrders/AddWorkOrders/SecondTab/SecondTab");
const PreviewDoc = () => import("@/modules/invoices/preview");
// validate
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
// helpers
import debounce from "lodash.debounce";
import getDefaultDate from "@/helper/getDefaultDate";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import Preload from "@/shared/Preload/Preload";
import TabBlock from "@/shared/TabBlock/TabBlock";
// constants
import { STATUS_COLOR } from "@/constants/constants";
import moment from "moment/moment";

export default {
	name: "AddWorkOrders",
	mixins: [ validationMixin ],
	components: {
		FirstTab,
		ButtonGroups,
		Preload,
		TabBlock,
		SecondTab,
		PreviewDoc
	},
	props: {
		currentId: Number,
		getPermissionAction: Boolean,
		permissions: Object
	},
	computed: {
		...mapGetters([ 'workOrders', 'workOrdersPreloader' ]),
		isArrivedBlock() {
			return this.wo_type_id === 2;
		},
		getStatus() {
			return this.status_id === 3 || this.status_id === 9;
		},
		getStatusInOut() {
			return this.wo_type_id === 1 && (this.status_id === 3 || this.status_id === 9);
		},
		getIndicatorColor() {
			const id = this.status_id?.id ?? this.status_id;
			return STATUS_COLOR[id];
		},
		getTabList() {
			const {
				request_date,
				current_mileage,
				reefer_hours
			} = this.$v;

			const values = [
				{
					text: 'General info',
					error: request_date.$error || current_mileage.$error || reefer_hours.$error
				},
				{
					text: 'Invoicing',
					error: false
				}
			];
			if (this.typeForm === 'create') {
				return values;
			}

			return [ ...values, { text: 'Logs', error: false } ];
		},
		getUnitId() {
			return this.unit_type_id?.id ?? this.unit_type_id;
		},
		getWorkOrderStatusList() {
			if (!this.flit_manager && !this.shop_manager) return this.workOrderStatusList;
			if (this.flit_manager && this.defaultStatus === 3 && this.wo_type_id === 2) {
				this.workOrderStatusList.forEach(item => item.disabled = !(item.id === 3 || item.id === 9 || item.id === 11));
			} else if (this.shop_manager) {
				this.workOrderStatusList.forEach(item => item.disabled = item.id === 9);
			} else {
				this.workOrderStatusList.forEach(item => item.disabled = this.wo_type_id !== 1 && item.id !== 11);
			}

			return this.workOrderStatusList;
		},
		isReefer() {
			return this.trailer_type === 'REEFER';
		}
	},
	data: () => ({
		isBoxHandler: false,
		link: null,
		isTab: true,
		dialog: true,
		tab: 0,
		customersList: [],
		requestFromList: [],
		technicianList: [],
		trailerList: [],
		truckList: [],
		workOrderStatusList: [],
		workOrderTypeList: [],
		workOrderUnitTypeList: [],
		unitList: [],
		customers: null,
		requestFrom: null,
		technician_id: null,
		trailer: null,
		truck: null,
		request_from: 1,
		request_date: getDefaultDate(1),
		arrival_date: "",
		estimated_time: "",
		arrival_amount: 0,
		arrival_text: '',
		reefer_hours: 0,
		actual_arrived_date: null,
		arrived: false,
		option_towing: false,
		option_alignment: false,
		option_pm: false,
		option_inspection: false,
		current_mileage: 0,
		notes: '',
		dispatch_request: 0,
		status_id: 10,
		defaultStatus: 10,
		wo_type_id: 2,
		unit_type_id: null,
		unit_id: null,
		customer_id: null,
		check_in: '',
		check_out: '',
		create_by: '',
		flit_manager: false,
		shop_manager: false,
		box: null,
		create_at: getDefaultDate(1),
		dispatchRequestList: [],
		trailer_type: '-',
		description: [],
		boxList: [],
		files: [],
		times: []
	}),
	validations() {
		return {
			check_in: this.getStatusInOut ? { required } : {},
			check_out: this.getStatusInOut ? { required } : {},
			current_mileage: this.getStatus && this.getUnitId === 1 ? { required, minValueValue: minValue(1) } : {},
			reefer_hours: this.getStatus && this.getUnitId === 2 && this.isReefer ? { required, minValueValue: minValue(1) } : {},
			customer_id: { required },
			request_date: { required },
			technician_id: { required },
			unit_id: { required },
			unit_type_id: { required }
		};
	},
	methods: {
		...mapActions([
			'onWorkOrdersCreate',
			'onWorkOrdersSave',
			'setAlert',
			'onWorkOrdersEdit',
			'onWorkOrdersDelete',
			'onInvoiceDelete',
			'getWorkOrdersDelete',
			'getInvoiceDelete',
			'getDispatcherList',
			'onWorkOrdersPreloader'
		]),
		onTab(value, key) {
			this[key] = value;
		},
		onPreviewAction(value) {
			this.link = value;
		},
		clearLink() {
			this.link = null;
		},
		onDescriptionList(item) {
			this.description.push(item);
		},
		onDeleteItem(idx) {
			this.description.splice(idx, 1);
		},
		closeDialog() {
			this.$emit('updateClose');
		},
		getValidTimes() {
			if (!this.check_in && !this.check_out) return true;
			return moment(this.check_in).isBefore(this.check_out);
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					customer_id,
					wo_type_id,
					unit_type_id,
					unit_id,
					check_in,
					check_out,
					technician_id,
					request_from,
					request_date,
					arrival_date,
					option_towing,
					arrival_amount,
					arrival_text,
					reefer_hours,
					notes,
					option_alignment,
					option_pm,
					option_inspection,
					current_mileage,
					dispatch_request,
					description: descriptionList,
					files,
					status_id,
					actual_arrived_date,
					arrived,
					estimated_time,
					/*				box,
					times*/
				} = this.$data;

				const description = descriptionList.filter(item => {
					if (!item.id) return { msg: item.msg };
				});

				const values = {
					customer_id,
					status_id,
					wo_type_id,
					unit_type_id,
					unit_id: unit_id?.id ?? unit_id,
					check_in,
					check_out,
					technician_id,
					request_from,
					request_date,
					arrival_date,
					arrival_amount,
					arrival_text,
					reefer_hours,
					notes,
					option_towing: Number(option_towing),
					option_alignment: Number(option_alignment),
					option_pm: Number(option_pm),
					option_inspection: Number(option_inspection),
					current_mileage: Number(current_mileage),
					dispatch_request,
					description,
					actual_arrived_date,
					arrived: Number(arrived),
					estimated_time,
					files
				};

				await this.onWorkOrdersPreloader(true);
				await this.onWorkOrdersDelete();
				await this.onInvoiceDelete();

				const validTime = this.getValidTimes();

				if (!validTime) {
					this.setAlert({ type: "error", message: "Start of work, should be less than the end of work" });
					await this.onWorkOrdersPreloader(false);
					return false;
				}

				const { status, error } = await this.onWorkOrdersSave({ values, id: this.currentId });

				if (status) {
					this.closeDialog();
					this.$emit('updateFilterList');
					this.getWorkOrdersDelete({ isDelete: true });
					this.getInvoiceDelete({ isDelete: true });
					this.setAlert({ type: "success", message: "Saving Successfully" });
					await this.onWorkOrdersPreloader(false);
				} else {
					const { unit_id, date } = error;
					const message = unit_id?.toString() || date?.toString() || "Saving error";
					await this.setAlert({ type: "error", message });
					await this.onWorkOrdersPreloader(false);
				}

			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		async onAutocomplete({ value }, key) {
			if (key !== 'unit_id') this[key] = value?.id ?? value;
			if (key === 'customer_id') {
				const id = value?.id;
				this.unit_type_id = 1;
				this.unit_id = null;
				const data = await this.onWorkOrdersCreate(id);

				if (data) {
					const { trailer, truck, technician } = data;
					this.trailerList = trailer;
					this.truckList = truck;
					this.technicianList = technician;
					this.unitList = this.truckList;
				}

				if (this.flit_manager) {
					const item = this.technicianList.find(item => item.id === this.flit_manager);
					this.technician_id = item?.id ?? null;
				}
			}

			if (key === 'wo_type_id' && value.id === 1) {
				this.arrival_date = null;
				this.actual_arrived_date = null;
				this.arrived = false;
				this.box = null;
			}

			if (key === "wo_type_id" && this.wo_type_id === 2 && this.flit_manager) {
				this.status_id = this.defaultStatus;
			}

			if (key === "wo_type_id" && this.shop_manager) {
				this.status_id = this.defaultStatus;
			}

			if (key === 'unit_id') {
				this.trailer_type = value?.type ?? '-';
				this[key] = value;
			}

			if (key === 'unit_type_id') {
				if (value.id === 1) {
					this.unitList = this.truckList;
				} else {
					this.unitList = this.trailerList;
				}

				this.unit_id = null;
			}
		},
		onTime(value, key) {
			this[key] = value;
		},
		getCurrentDispatchList: debounce(async function(value) {
			const date = value.slice(0, 10);
			const values = this.currentId ? { date, id: this.currentId } : { date };
			this.dispatchRequestList = await this.getDispatcherList(values);
			if (this.dispatchRequestList.length) this.dispatch_request = this.dispatchRequestList[0].id;
		}, 300),
		setActualDate(value) {
			this.actual_arrived_date = value ? `${ getDefaultDate(1) }` : null;
		},
		async onFirstTab({ value, key }) {
			if (key === 'arrived') this.setActualDate(value);
			if (key === 'request_date') this.getCurrentDispatchList(value);
			this[key] = value;
		},
		onClearInput(array) {
			array.forEach(({ value, key }) => {
				this[key] = value;
			});
		},
		onBoxHandler() {
			this.isBoxHandler = !this.isBoxHandler;
		}
	},
	async mounted() {
		this.onWorkOrdersPreloader(true);
		if (this.currentId) {
			await this.onWorkOrdersEdit(this.currentId);
		} else {
			await this.onWorkOrdersCreate(null);
		}

		const {
			customers,
			request_from,
			technician,
			trailer,
			truck,
			workOrderStatus,
			workOrderType,
			workOrderUnitType,
			create_by,
			dispatch_request: dispatchRequestList,
			workOrder,
			description,
			files,
			box,
			times,
			flit_manager,
			shop_manager
		} = this.workOrders;

		this.customersList = customers;
		this.requestFromList = request_from;
		this.technicianList = technician;
		this.trailerList = trailer;
		this.truckList = truck;
		this.workOrderStatusList = workOrderStatus;
		this.workOrderTypeList = workOrderType;
		this.dispatchRequestList = dispatchRequestList;
		this.workOrderUnitTypeList = workOrderUnitType;
		this.isTab = false;
		this.create_by = create_by;
		this.files = files || [];
		this.times = times || [];
		this.description = description || [];
		this.boxList = box || [];
		this.flit_manager = flit_manager;
		this.shop_manager = shop_manager;

		if (workOrder) {
			if (workOrder['unit_type_id'] === 1) {
				this.unitList = this.truckList;
			} else {
				this.unitList = this.trailerList;
			}

			for (const workOrderKey in workOrder) {
				this[workOrderKey] = workOrderKey.includes('option') || workOrderKey === "arrived" ? Boolean(workOrder[workOrderKey]) : workOrder[workOrderKey];
			}

			if (workOrder['unit_id']) {
				this.unit_id = this.unitList.find(item => item.id === workOrder['unit_id']);
			}

			this.defaultStatus = this.status_id;
		}

		this.onWorkOrdersPreloader(false);
	}
};
</script>

<style scoped lang="scss">
@import "addWorkOrders";
</style>

<style lang="scss">
@import "addWorkOrdersAll";
</style>
